import * as React from "react"
import { StoreProvider } from "./src/context/store-context"
import "./src/styles/reset.css"
import "@popperjs/core/dist/umd/popper.min"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min"
import "./src/styles/variables.css"
import "./src/styles/global.css"

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
	const currentPosition = getSavedScrollPosition(location)
	setTimeout(() => {
		window.scrollTo(...(currentPosition || [0, 0]))
	}, 0)
	
	return false
}

export const wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
)
